import {
  Compare,
  compareDatabaseProjectionTypedValues,
  type DatabaseProjectionValueType,
} from '@streamlain/database-identity';
export { Compare };
export type CompareType = keyof typeof Compare | number;
import type { VariableRef } from '../expression/types.js';
import { t } from '../logical/index.js';
import type { TypeInstance } from '../logical/type.js';
import type { Row, SingleView } from '../view-manager/index.js';
import type { Sort } from './types.js';

const evalRef = (
  view: SingleView,
  ref: VariableRef
):
  | ((row: Row) => {
      value: unknown;
      ttype?: TypeInstance;
    })
  | undefined => {
  const ttype = view.propertyGetOrCreate(ref.name).dataType$.value;
  return row => ({
    value: view.cellGetOrCreate(row.rowId, ref.name).jsonValue$.value,
    ttype,
  });
};
/** How the table view compares the values of `type`, as the shared sort reads it. */
export function projectionValueType(
  type: TypeInstance
): DatabaseProjectionValueType {
  if (t.array.is(type))
    return { name: type.name, element: projectionValueType(type.element) };
  return { name: type.name, data: t.tag.is(type) ? type.data : undefined };
}

export const compareTypedValues = (
  type: TypeInstance,
  a: unknown,
  b: unknown,
  desc = false
): number =>
  compareDatabaseProjectionTypedValues(projectionValueType(type), a, b, desc);

export const evalSort = (
  sort: Sort,
  view: SingleView
): ((rowA: Row, rowB: Row) => number) | undefined => {
  if (sort.sortBy.length) {
    const sortBy = sort.sortBy.map(sort => {
      return {
        ref: evalRef(view, sort.ref),
        desc: sort.desc,
      };
    });
    return (rowA, rowB) => {
      for (const sort of sortBy) {
        const refA = sort.ref?.(rowA);
        const refB = sort.ref?.(rowB);
        const result = compareTypedValues(
          refA?.ttype ?? t.unknown.instance(),
          refA?.value,
          refB?.value,
          sort.desc
        );
        if (result !== 0) {
          return result;
        }
        continue;
      }
      return 0;
    };
  }
  return;
};
